export default function LoadingScreen() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-[#F1F5F9] gap-4">
      <div className="w-12 h-12 border-4 border-slate-200 border-t-[#0054A6] rounded-full animate-spin"></div>
      <p className="text-[#0054A6] text-xs font-black uppercase tracking-[0.3em]">
        Loading System
      </p>
    </div>
  );
}